import axios from '@/libs/http'
import http from '@/libs/http'

/**
 * 获取用户详情
 */
export const getUser = (id) => {
    return axios.request({
        url: '/s/a/user/get',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 修改用户是否黑名单
 * */
// export const updateBlacklist = (id, isBlacklist) => {
//     return axios.request({
//         url: '/s/a/user/updateBlacklist',
//         params: {
//             id,
//             isBlacklist
//         },
//         method: 'post'
//     })
// }

export const updateBlacklist = (id, isBlacklist, blacklistConent, fileList) => {
    const data = new URLSearchParams();
    data.append("id", id);
    data.append("isBlacklist", isBlacklist);
    data.append("blacklistConent", blacklistConent);
    data.append("fileList", fileList);
    return http.request({
        url: '/s/a/user/updateBlacklist',
        data,
        method: 'post'
    })
}

export const queryBlacklist = (id) => {
    return http.request({
        url: '/s/a/user/queryBlacklist',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 修改用户是否需要实名认证
 * */
export const updateRequireVerify = (id, requireVerify) => {
    return axios.request({
        url: '/s/a/user/updateRequireVerify',
        params: {
            id,
            requireVerify
        },
        method: 'post'
    })
}
/**
 * 修改用户是否黑名单
 * */
export const clearVerify = (id) => {
    return axios.request({
        url: '/s/a/user/clearVerify',
        params: {
            id,
        },
        method: 'post'
    })
}
/**
 * 修改用户违规状态
 * */
export const updateViolation = (userId, isViolation, type, fileList) => {
    var data = new URLSearchParams();
    data.append("userId", userId);
    data.append("isViolation", isViolation)
    if(type != null){
        data.append("type", type)
    }
    if(fileList){
        data.append(  "fileList", fileList)
    }
    return axios.request({
        url: '/s/a/user/updateViolation',
        data,
        method: 'post'
    })
}

/**
 * 查看有没有下单
 */
export const isPlaceAnOrder = (userId) => {
    return axios.request({
        url: '/s/a/user/isPlaceAnOrder',
        params: {
            userId
        },
        method: 'get'
    })
}
